/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcOrgInfo } from './vmcOrgInfo';
import { VmcInfoSummary } from './vmcInfoSummary';


export interface VmcInfoResult { 
    /**
     * Time at which result was created and cached
     */
    generated_at: string;
    time_elapsed_sec: number;
    summary: VmcInfoSummary;
    vmc_org_info: Array<VmcOrgInfo>;
}

